import tips from './tips'
import links from './links'
import descriptions from './descriptions'
import message from './message'
export default { ...tips, ...links, ...descriptions, ...message }
